<template>
  <div class="summary-card">
    <div class="summary-card__icon" :class="`summary-card__icon--${color}`">
      <fluent-icon :icon="icon" size="24" />
    </div>
    <div class="summary-card__content">
      <p class="summary-card__title">{{ title }}</p>
      <p class="summary-card__value">{{ value }}</p>
      <p v-if="subtitle" class="summary-card__subtitle">{{ subtitle }}</p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    icon: { type: String, required: true },
    title: { type: String, required: true },
    value: { type: String, required: true },
    subtitle: { type: String, default: '' },
    color: {
      type: String,
      default: 'blue',
      validator: value => ['blue', 'green', 'yellow', 'red'].includes(value),
    },
  },
};
</script>

<style scoped lang="scss">
.summary-card {
  align-items: center;
  background: var(--white);
  border: 1px solid var(--s-100);
  border-radius: var(--border-radius-large);
  display: flex;
  gap: var(--space-normal);
  padding: var(--space-normal);
}

.summary-card__icon {
  align-items: center;
  border-radius: var(--border-radius-medium);
  display: flex;
  flex-shrink: 0;
  height: var(--space-larger);
  justify-content: center;
  width: var(--space-larger);

  &--blue {
    background: var(--b-50);
    color: var(--b-500);
  }

  &--green {
    background: var(--g-50);
    color: var(--g-500);
  }

  &--yellow {
    background: var(--y-50);
    color: var(--y-700);
  }

  &--red {
    background: var(--r-50);
    color: var(--r-500);
  }
}

.summary-card__title {
  color: var(--s-500);
  font-size: var(--font-size-small);
  margin: 0;
}

.summary-card__value {
  font-size: var(--font-size-big);
  font-weight: var(--font-weight-bold);
  margin: var(--space-micro) 0 0;
}

.summary-card__subtitle {
  color: var(--s-500);
  font-size: var(--font-size-mini);
  margin: var(--space-micro) 0 0;
}
</style>
